var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.41667 1.16667H5.25C2.33333 1.16667 1.16667 2.33333 1.16667 5.25V8.75C1.16667 11.6667 2.33333 12.8333 5.25 12.8333H8.75C11.6667 12.8333 12.8333 11.6667 12.8333 8.75V7.58333",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.35667 1.76167L4.76 6.35833C4.585 6.53333 4.41 6.8775 4.375 7.12833L4.12417 8.88417C4.03083 9.52 4.48 9.96333 5.11583 9.87583L6.87167 9.625C7.11667 9.59 7.46083 9.415 7.64167 9.24L12.2383 4.64333C13.0317 3.85 13.405 2.92833 12.2383 1.76167C11.0717 0.595 10.15 0.968333 9.35667 1.76167Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.6975 2.42083C9.08833 3.815 10.1792 4.90583 11.5792 5.3025",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.cc946a8cf287140c811f072b4160f0e5.svg";
export { ForwardRef as ReactComponent };